// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AngleUpSmall: React.FC<{ width?: number; height?: number }> = ({ width = 9, height = 5 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 9 5">
            <path
                fill="currentColor"
                d="M4.096.163a.582.582 0 0 1 .808 0l3.913 3.855a.55.55 0 0 1 0 .82.582.582 0 0 1-.807 0L4.512 1.391 1.015 4.837c-.245.217-.611.217-.832 0a.55.55 0 0 1 0-.819L4.096.163Z"
            />
        </svg>
    );
};

export default React.memo(AngleUpSmall);
